module.exports = __webpack_public_path__ + "img/1080_19.d70343f0.jpg";